import { useMic } from "../hooks/useMic";

/**
 * Maintenir pour parler, relâcher pour envoyer. Le clip coupe la musique de tout
 * le monde quelques secondes plus tard.
 */
export function MicButton({ onDuck }: { onDuck: (ducked: boolean) => void }) {
  const mic = useMic(onDuck);
  const recording = mic.state === "recording";
  const seconds = Math.floor(mic.elapsedMs / 1000);

  return (
    <div className="mic">
      <button
        className={`btn btn--mic${recording ? " btn--mic-live" : ""}`}
        type="button"
        disabled={mic.state === "sending"}
        onPointerDown={() => void mic.start()}
        onPointerUp={() => void mic.stop()}
        onPointerLeave={() => recording && void mic.stop()}
      >
        {mic.state === "sending" ? "envoi…" : recording ? `● ${seconds}s — relâche` : "🎙️ prendre le mic"}
      </button>
      {mic.error && <span className="mic__error">{mic.error}</span>}
    </div>
  );
}
